import React, { useEffect, useRef } from "react";
import { useNav } from "../../../shared/context";

export const NavAnchor = () => {
  const ref = useRef<HTMLDivElement>(null);
  const { registerAnchor, unregisterAnchor } = useNav();

  useEffect(() => {
    const el = ref.current;
    if (el) registerAnchor(el);

    return () => {
      if (el) unregisterAnchor(el);
    };
  }, [registerAnchor, unregisterAnchor]);

  return <div ref={ref} style={{ height: 0 }} />;
};
